import React, { Component } from 'react';
import { Check, Mail, HelpCircle, ShieldCheck, Lock, Star, PlayCircle } from 'lucide-react';
const CTAButton = ({
  className = ''
}: {
  className?: string;
}) => <div data-id="element-2040" data-mp="3li962tx3l1w">
    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className={`block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-4 px-4 rounded-lg text-center transition-colors shadow-lg ${className}`} data-id="element-2041" data-mp="3m9zoz8nqslb">
      <span className="block text-sm font-normal mb-1" data-id="element-2042" data-mp="3315ckwwgpykb">Ga naar stap #2</span>
      <span className="block text-xl" data-id="element-2043" data-mp="32z2d7m9f6t2x">Start de cursus nu</span>
    </a>
    <img src="https://cdn.magicpatterns.com/uploads/4vdV4HP3iomaCgiRo35kk3/ORAweI9onQltdmefOLBalrxDMg.png" alt="Betaalmethoden: Mastercard, CB, Apple Pay, iDEAL, SEPA, Visa, PayPal, American Express, Klarna, Bancontact" className="mx-auto mt-3 h-10 w-auto max-w-[280px] opacity-80" data-id="element-2044" data-mp="3gtuzr4nq99j0" />
  </div>;
const PricingCard = () => <div className="bg-white rounded-xl shadow-xl p-6 border-t-8 border-[#5ce0d2] text-center flex flex-col h-full" data-id="element-2045" data-mp="36lecuuz70cwz">
    <h3 className="text-[#5ce0d2] font-extrabold text-xl md:text-2xl mb-1 uppercase tracking-wide" data-id="element-2046" data-mp="3bjzemyu3f4nj">
      Liefdevol Communiceren
    </h3>
    <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-6" data-id="element-2047" data-mp="3gbputlfpommv">
      Pakket Actie
    </h2>

    <div className="mb-6" data-id="element-2048" data-mp="3l9rea7h1unyv">
      <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus - training op laptop, tablet en telefoon" className="w-full h-auto object-contain" data-id="element-2049" data-mp="3lc5709o9bo39" />
    </div>

    {/* What's included */}
    <div className="text-left space-y-2 mb-6 bg-[#faf5eb] rounded-lg p-4" data-id="element-2050" data-mp="2xmsylc0r7k20">
      <div className="flex items-start gap-2" data-id="element-2051" data-mp="32kktmewp3maf">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2052" data-mp="cuhbsy98zgqk" />
        <p className="text-sm text-gray-700" data-id="element-2053" data-mp="cwlh9kmsonsy">
          <span className="font-bold" data-id="element-2054" data-mp="hssorhuua7d0">Liefdevol Communiceren Cursus</span>{' '}
          <span className="text-gray-500" data-id="element-2055" data-mp="2dwglneqexjk6">(€197)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-2056" data-mp="2dyta8aqoes67">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2057" data-mp="28yf26sp2ri86" />
        <p className="text-sm text-gray-700" data-id="element-2058" data-mp="2mx50ucrjlpyn">
          <span className="font-bold" data-id="element-2059" data-mp="2mw3lvx7eojbn">2 gratis aanvullende cursussen</span> naar
          keuze <span className="text-gray-500" data-id="element-2060" data-mp="2iwuwf4jef7lw">(€160)</span>
        </p>
      </div>
      <div className="flex items-start gap-2" data-id="element-2061" data-mp="1v5pi4tt3wndp">
        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2062" data-mp="1v6h217dccwo5" />
        <p className="text-sm text-gray-700" data-id="element-2063" data-mp="1q874iq459jzd">
          <span className="font-bold" data-id="element-2064" data-mp="1q5b7r54191ci">Digitaal boek "Wat Zegt Jouw Hond?"</span>{' '}
          <span className="text-gray-500" data-id="element-2065" data-mp="240nc847zq66m">(€44)</span>
        </p>
      </div>
    </div>

    <div className="text-gray-500 text-base mb-1" data-id="element-2066" data-mp="1z699thuwuysg">
      Totale waarde: <span className="line-through" data-id="element-2067" data-mp="1bhgcbgyn4ivq">€401</span>
    </div>
    <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-2068" data-mp="1bfvjpwvvza0i">Nu voor €127</div>
    <div className="text-[#e53e3e] font-bold text-lg mb-6" data-id="element-2069" data-mp="17ged304q46tr">(Bespaar €274)</div>

    <p className="text-[#22c55e] font-bold text-sm mb-6" data-id="element-2070" data-mp="xbxy08z2itr0">
      Nu beschikbaar voor directe toegang
    </p>

    <CTAButton className="mb-4" data-id="element-2071" data-mp="124zdai36svb4" />

    <div className="text-xs text-gray-500 space-y-2 mt-auto pt-4" data-id="element-2072" data-mp="nejt96mibtej">
      <p className="flex items-center justify-center gap-1" data-id="element-2073" data-mp="ngd1gqcrqlon">
        <Lock className="w-4 h-4" data-id="element-2074" data-mp="sctpzlnvr229" /> 100% veilig afrekenen
      </p>
      <p className="flex items-center justify-center gap-1" data-id="element-2075" data-mp="1g37jzhq0zazh">
        <ShieldCheck className="w-4 h-4" data-id="element-2076" data-mp="1g3qonwqo02vk" /> Met onze 100% geld terug garantie
      </p>
    </div>
  </div>;
const PakketActieSection = () => {
  const cursussen = [{
    title: 'Cursus Uitvallen',
    desc: 'Voor honden die uitvallen naar andere honden of mensen tijdens het wandelen.',
    icon: '🐕'
  }, {
    title: 'Cursus Stress bij Wandelen',
    desc: 'Help je hond ontspannen tijdens elke wandeling, ook in drukke omgevingen.',
    icon: '🚶'
  }, {
    title: 'Cursus Overmatig Blaffen',
    desc: 'Ontdek waarom je hond blaft en hoe je dit op een liefdevolle manier vermindert.',
    icon: '🔊'
  }, {
    title: 'Puppycursus',
    desc: 'Begin je puppy-leven goed met de juiste basis in communicatie en vertrouwen.',
    icon: '🐶'
  }, {
    title: 'Cursus Opspringen',
    desc: 'Leer je hond rustig te begroeten zonder springen, zonder corrigeren.',
    icon: '🦴'
  }, {
    title: 'Cursus Verlatingsangst',
    desc: 'Help je hond ontspannen alleen thuis te zijn, stap voor stap.',
    icon: '🏠'
  }, {
    title: 'Cursus Geluidsangst',
    desc: 'Ondersteun je hond bij vuurwerk, onweer en andere harde geluiden.',
    icon: '⚡'
  }];
  return <section className="bg-[#faf5eb] py-16 md:py-20" data-id="element-2077" data-mp="jy73ygfwlf1v">
      <div className="max-w-6xl mx-auto px-4" data-id="element-2078" data-mp="jxfgjswgmnmo">
        <div className="text-center mb-12" data-id="element-2079" data-mp="39niyd9jwqt6j">
          <span className="inline-block bg-[#e53e3e] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4" data-id="element-2080" data-mp="39oatkj9leowa">
            Pakket Actie - Tijdelijk Aanbod
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-[#1a2b4a] mb-4" data-id="element-2081" data-mp="1k3stdmoeusle">
            Dit krijg je allemaal voor{' '}
            <span className="text-[#e53e3e]" data-id="element-2082" data-mp="1u4bj2y2np3b8">€127</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2083" data-mp="1u1yqzs36pckg">
            Niet alleen de Liefdevol Communiceren Cursus, maar een compleet
            pakket dat jou en je hond op elk vlak ondersteunt - met een totale
            waarde van{' '}
            <span className="font-bold line-through text-gray-500" data-id="element-2084" data-mp="27uos73raao25">€401</span>.
          </p>
        </div>

        {/* 3 Components Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-2085" data-mp="2cvcejc4kigq1">
          {/* 1. Hoofdcursus */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-2086" data-mp="2ht48scsoqexe">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-2087" data-mp="iimm6ytulfkr">
              Onderdeel 1
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-2088" data-mp="ffyo7j29534k">
              <img src="https://cdn.magicpatterns.com/uploads/sZnnt8dxKLASfHTcPAVy58/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus" className="w-full h-32 object-contain mb-4" data-id="element-2089" data-mp="bdbrb3qq4s0i" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-2090" data-mp="kd8fz5d45qvk">
                Liefdevol Communiceren Cursus
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-2091" data-mp="ybezfghbfobp">
                De complete online cursus waarin je leert de taal van je hond te
                begrijpen en zelf liefdevol terug te communiceren.
              </p>
              <div className="text-right" data-id="element-2092" data-mp="133zqwbcr1pc2">
                <span className="text-gray-400 line-through" data-id="element-2093" data-mp="1359q53vc93ka">€197</span>
              </div>
            </div>
          </div>

          {/* 2. Twee cursussen */}
          <div className="bg-white rounded-2xl shadow-md border-2 border-[#ffb800] overflow-hidden flex flex-col relative" data-id="element-2094" data-mp="1d3gtgjwpfn3t">
            <div className="bg-[#ffb800] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-2095" data-mp="1wpscte1aierz">
              Onderdeel 2 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-2096" data-mp="1mp8a06y4h27n">
              <div className="w-full h-32 flex items-center justify-center mb-4 bg-gradient-to-br from-[#e6f7f5] to-[#faf5eb] rounded-lg" data-id="element-2097" data-mp="1msnu5o6nl1fx">
                <div className="text-5xl" data-id="element-2098" data-mp="1d08bsprg2aui">🎁</div>
              </div>
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-2099" data-mp="1hr6u1uvztj0e">
                2 Aanvullende Cursussen naar keuze
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-2100" data-mp="1413bbdwbo7fp">
                Kies tijdens het afrekenen 2 cursussen uit de lijst hieronder
                die het beste bij jouw situatie passen.
              </p>
              <div className="text-right" data-id="element-2101" data-mp="u25pwju70u0x">
                <span className="text-gray-400 line-through" data-id="element-2102" data-mp="z0fn0zzha4p6">€160</span>
              </div>
            </div>
          </div>

          {/* 3. Boek */}
          <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden flex flex-col" data-id="element-2103" data-mp="1ei6us5vhlyxy">
            <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-2 px-4 font-bold text-xs uppercase tracking-wider" data-id="element-2104" data-mp="1ahwmuno4wygg">
              Onderdeel 3 - Gratis Bonus
            </div>
            <div className="p-6 flex-1 flex flex-col" data-id="element-2105" data-mp="10iflgifx16qa">
              <img src="https://cdn.magicpatterns.com/uploads/6GVCL5WQtpsTAWZp3DJ7Rr/boek_mockup_wat_zegt_jouw_hond_(2).png" alt='Boek "Wat Zegt Jouw Hond?"' className="w-full h-32 object-contain mb-4" data-id="element-2106" data-mp="vjm94tcd7lrp" />
              <h3 className="font-black text-xl text-[#1a2b4a] mb-2" data-id="element-2107" data-mp="mpg8oo7ipqmf">
                Boek "Wat Zegt Jouw Hond?"
              </h3>
              <p className="text-sm text-gray-600 mb-4 flex-1" data-id="element-2108" data-mp="ct3elp829ar5">
                De digitale versie van ons boek over hondentaal. Voor op je
                mobiel, tablet, computer of om uit te printen.
              </p>
              <div className="text-right" data-id="element-2109" data-mp="3twisec2ci39w">
                <span className="text-gray-400 line-through" data-id="element-2110" data-mp="3txtrhykuimuo">€44</span>
              </div>
            </div>
          </div>
        </div>

        {/* Choose 2 from 7 */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-10 mb-10" data-id="element-2111" data-mp="7pu8v1k754x6">
          <div className="text-center mb-8" data-id="element-2112" data-mp="cmawzvrebja9">
            <h3 className="text-2xl md:text-3xl font-black text-[#1a2b4a] mb-3" data-id="element-2113" data-mp="3b59fdstd8wdk">
              Kies tijdens het afrekenen 2 cursussen naar keuze
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-2114" data-mp="3g4udk10pp0p8">
              Welke uitdaging ervaar jij met je hond? Tijdens het afrekenen
              krijg je de keuze uit deze 7 cursussen - kies de 2 die jij
              waardevol vindt.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2115" data-mp="2sfjld7xfgemp">
            {cursussen.map((c, i) => <div key={i} className="bg-[#faf5eb] rounded-xl p-4 border border-gray-100 hover:border-[#5ce0d2] transition-colors flex gap-3 items-start" data-id="element-2116" data-mp="2xctasnktgqaj" data-mpi={i}>
                <div className="text-3xl flex-shrink-0" data-id="element-2117" data-mp="37etbyakxcmvw">{c.icon}</div>
                <div data-id="element-2118" data-mp="3ceo4sjo9fmjl">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-1" data-id="element-2119" data-mp="3cg8zqaehl7hz">
                    {c.title}
                  </p>
                  <p className="text-xs text-gray-600 leading-relaxed" data-id="element-2120" data-mp="3gfzvytms8ftw">
                    {c.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-sm text-gray-500 mt-6 italic" data-id="element-2121" data-mp="2oq4szu604rmr">
            Twijfel je nog? Geen zorgen - je kunt je keuze tijdens het afrekenen
            rustig maken.
          </p>
        </div>

        {/* Summary + CTA */}
        <div className="bg-[#1a2b4a] rounded-2xl p-8 md:p-12 text-center text-white shadow-xl" data-id="element-2122" data-mp="2100qjq4juxxc">
          <p className="text-sm uppercase tracking-wider text-[#5ce0d2] font-bold mb-3" data-id="element-2123" data-mp="251mdk4asssl9">
            Het Liefdevol Communiceren Pakket
          </p>
          <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-2124" data-mp="1xgtmqh4wgcsu">
            Cursus + 2 vrije cursussen + boek
          </h3>
          <div className="flex flex-col items-center mb-6" data-id="element-2125" data-mp="1sjtcrv4xipwg">
            <span className="text-lg text-gray-400 line-through mb-1" data-id="element-2126" data-mp="1ogn9mwd45eu7">
              Totale waarde €401
            </span>
            <span className="text-5xl md:text-6xl font-black text-[#ffb800]" data-id="element-2127" data-mp="1jhtwx65nhrv3">
              €127
            </span>
            <span className="text-[#5ce0d2] font-bold text-lg mt-1" data-id="element-2128" data-mp="1elbw2hdfydo1">
              Je bespaart €274
            </span>
          </div>
          <div className="max-w-md mx-auto" data-id="element-2129" data-mp="14t64h8r3py9d">
            <CTAButton data-id="element-2130" data-mp="14tz31mfwphgf" />
          </div>
          <div className="text-xs text-gray-400 mt-6 flex flex-wrap items-center justify-center gap-4" data-id="element-2131" data-mp="10rudozwhr6zl">
            <span className="flex items-center gap-1" data-id="element-2132" data-mp="vsrevx73tx02">
              <Lock className="w-4 h-4" data-id="element-2133" data-mp="vs81mtsefwsd" /> 100% veilig afrekenen
            </span>
            <span className="flex items-center gap-1" data-id="element-2134" data-mp="qupr4yyqh9i9">
              <ShieldCheck className="w-4 h-4" data-id="element-2135" data-mp="h6295dm9enl8" /> 365 dagen geld-terug
            </span>
          </div>
        </div>
      </div>
    </section>;
};
export function LiefdevolCommunicerenACPage() {
  return <div className="min-h-screen bg-[#faf5eb] font-sans text-gray-800 pb-24 md:pb-0" data-id="element-2136" data-mp="784kip0hmos3">
      {/* 1. HEADER */}
      <div className="bg-white py-3 px-4" data-id="element-2137" data-mp="c6fwp6e99bdh">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2138" data-mp="c7hfxy5fd46a">
          <div className="flex-1 hidden md:block" data-id="element-2139" data-mp="zxbssfpqusqj"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-2140" data-mp="14vwjnoj3w02b" />
          <div className="flex-1 flex justify-center md:justify-end" data-id="element-2141" data-mp="v48vbwhuiz52">
            <a href="mailto:amee@stresslessdogs.nl" className="flex items-center text-sm font-bold text-[#1a2b4a] hover:text-[#5ce0d2] transition-colors" data-id="element-2142" data-mp="1iud2gdu8th0t">
              <Mail className="w-5 h-5 mr-2" data-id="element-2143" data-mp="38brvz0eefauf" />
              Hulp nodig? Mail mij op amee@stresslessdogs.nl
            </a>
          </div>
        </div>
      </div>

      {/* 2. SUB BANNER */}
      <div className="bg-[#EDEDED] text-[#1a2b4a] text-center py-4 px-4 font-bold text-sm md:text-base tracking-wide" data-id="element-2144" data-mp="3i2mfvy469ycp">
        Voor baasjes die eindelijk de verborgen taalbarrière met hun hond willen
        doorbreken (en een echte, diepe band willen opbouwen)
      </div>

      {/* 3. HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-16" data-id="element-2145" data-mp="2kfe1so6i3rkq">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#1a2b4a] text-center mb-6 leading-tight" data-id="element-2146" data-mp="2yedpntm6w2fu">
          Jouw hond is niet 'koppig' of 'ongehoorzaam' - je spreekt zijn taal
          niet. Ontdek hoe je vloeiend de hondentaal leert spreken in 3 stappen.
        </h1>
        <p className="text-lg md:text-2xl text-center text-gray-700 mb-12 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-2147" data-mp="dpzdte73xkd7">
          Zodat jij je hond écht begrijpt, je probleemgedrag kan stoppen zonder
          straffen of corrigeren en jullie de meest liefdevolle band krijgen die
          je als baasje met je hond kan hebben.
        </p>

        <div className="grid md:grid-cols-12 gap-8 items-start" data-id="element-2148" data-mp="1dx4ohxcudfbp">
          <div className="md:col-span-8" data-id="element-2149" data-mp="1iwhegqz0f2ii">
            <div className="rounded-xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-2150" data-mp="1ixirv23i013e">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-2151" data-mp="1nusn4ydkj6z5">
                <iframe src="https://player.vimeo.com/video/1099360202?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="Hero Video" data-id="element-2152" data-mp="1wo5pss1fpmyf"></iframe>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 underline cursor-pointer" data-id="element-2153" data-mp="3r2jabo9yj7m0">
              Klik op afspelen om de video te starten
            </p>

            {/* Wat is de nieuwe Verlatingsangst Kernaanpak? - direct under video */}
            <div className="mt-8" data-id="element-2154" data-mp="io131orubw3g">
              <h2 className="text-3xl font-bold text-[#5ce0d2] mb-4 text-center" data-id="element-2155" data-mp="imzjsx0o83an">
                Wat is de Liefdevol Communiceren Methode?
              </h2>
              <div className="text-lg text-gray-700 leading-relaxed space-y-4" data-id="element-2156" data-mp="8y7wx3agw96l">
                <p data-id="element-2157" data-mp="8w4vzo7s0vn3">
                  De Liefdevol Communiceren Methode is een stap voor stap aanpak
                  die hondenbaasjes helpt om de verborgen taal van hun hond te
                  leren lezen, te begrijpen en zelf vloeiend terug te spreken.
                </p>
                <p data-id="element-2158" data-mp="wmr3nedvcdwk">
                  We laten je precies zien hoe jouw hond de hele dag met je
                  communiceert via subtiele lichaamssignalen, en hoe jij op een
                  manier terugpraat die hij van nature begrijpt - zonder dwang,
                  straf of dominantie.
                </p>
                <p className="font-bold text-[#1a2b4a]" data-id="element-2159" data-mp="2h4a06lnqvgk4">
                  Zodat jullie relatie niet gebaseerd is op gehoorzaamheid, maar
                  op wederzijds begrip en vertrouwen. (Waardoor je hond naar je
                  gaat luisteren omdat die je begrijpt, je vertrouwt en je
                  respecteert).
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-4" data-id="element-2160" data-mp="1y9l992wtv6ny">
            <PricingCard data-id="element-2161" data-mp="235jtqff1c4j3" />
          </div>
        </div>
      </section>

      {/* 6. VOOR WIE WERKT DIT */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-2162" data-mp="3smb3jlr3yhvv">
        {/* 6. VOOR WIE WERKT DIT */}
        <div className="bg-white rounded-xl shadow-md p-8 mb-12 border border-gray-100" data-id="element-2163" data-mp="1dx9cwpnf7vl">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-2164" data-mp="1lw7s4o78evwr">
            Voor wie werkt dit
          </h3>
          <p className="mb-6 text-gray-700" data-id="element-2165" data-mp="1gyz62ciyq7q8">
            Voor alle baasjes die worstelen met gedragsproblemen en het gevoel
            hebben dat ze hun hond niet echt begrijpen:
          </p>
          <ul className="space-y-4" data-id="element-2166" data-mp="1qvu7p4aj8o8q">
            {['Het maakt niet uit als je nog nooit eerder iets hebt geleerd over hondentaal of lichaamssignalen.', 'De methode is eenvoudig en direct toepasbaar. Met slechts 30 minuten per dag zie je binnen een week al de eerste verbeteringen, en binnen twee tot vier weken ontstaat er een compleet nieuwe relatie.', 'Geschikt voor honden van alle leeftijden, rassen en formaten.', 'Werkt ook bij angstige honden, overprikkelde honden of honden met een rugzakje'].map((item, i) => <li key={i} className="flex items-start" data-id="element-2167" data-mp="f9caomx9t993" data-mpi={i}>
                <Check className="w-6 h-6 text-[#22c55e] mr-3 flex-shrink-0 mt-0.5" data-id="element-2168" data-mp="fax3a700yi4b" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-2169" data-mp="3pkj122v9p4zs">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Desire Stack */}
          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-2170" data-mp="35zuutgg4w4e">
            <h4 className="text-xl font-bold text-[#1a2b4a] mb-4" data-id="element-2171" data-mp="839ic3k9yxpl">
              Stel je voor dat je straks…
            </h4>
            <ul className="space-y-3" data-id="element-2172" data-mp="36nhsk82i8mr3">
              {['Precies weet hoe je je hond op zijn gemak stelt als hij onrustig wordt - zonder te schreeuwen of te corrigeren.', 'Zijn stresssignalen herkent vóórdat het escaleert, zodat je hem kunt geruststellen op het moment dat hij het nodig heeft.', 'Ontspannen kunt wandelen zonder constant alert te zijn op andere honden of mensen.', "Zonder commando's communiceert met je hond, gewoon door je lichaamstaal - en hij begrijpt je meteen.", 'Visite kunt ontvangen zonder dat je hond door het lint gaat of dat jij je moet verontschuldigen.', 'Eindelijk die diepe, rustige band voelt waar je altijd van hebt gedroomd - elke dag opnieuw.'].map((item, i) => <li key={`desire-${i}`} className="flex items-start" data-id="element-2173" data-mp="2bj3bb201yaer" data-mpi={i}>
                  <Star className="w-5 h-5 text-[#ffb800] mr-3 flex-shrink-0 mt-0.5" data-id="element-2174" data-mp="26lbmwhym96fb" />
                  <span className="text-gray-700 text-lg" data-id="element-2175" data-mp="21o30g56fqg89">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* 7. MET DE METHODE */}
        <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-2176" data-mp="1slk13v1uylqr">
          Met de Liefdevol Communiceren Methode…
        </h3>
        <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-2177" data-mp="1nok3m8j2qrb9">
          <p data-id="element-2178" data-mp="3mzbjbiy96dxt">
            ...leer je in drie stappen de taal van je hond te lezen én te
            spreken, zodat jullie eindelijk op één lijn zitten en
            gedragsproblemen vanzelf verminderen.
          </p>
          <p data-id="element-2179" data-mp="f55k2nn98dbf">
            Waardoor je hond zich begrepen voelt en jullie samenwerking soepeler
            gaat dan je ooit voor mogelijk hield.
          </p>
          <p className="font-bold text-[#1a2b4a]" data-id="element-2180" data-mp="5gdqyc6gjmyx">
            Geen frustratie meer dat je alles hebt geprobeerd maar niets werkt.
          </p>
        </div>

        <div className="mb-12 rounded-xl overflow-hidden shadow-lg" data-id="element-2181" data-mp="hapt2tlm0w8">
          <img src="https://cdn.magicpatterns.com/uploads/fGHv8ypZfDoYKf4ChjPLqb/IMG-20171008-WA0012.jpg" alt="Hond ontspannen op de bank terwijl baasje weggaat" className="w-full h-auto object-cover" data-id="element-2182" data-mp="3ron5teiqw8ak" />
        </div>

        {/* 8. SIGNALEN */}
        <div className="bg-[#e6f7f5] rounded-xl p-8 mb-12" data-id="element-2183" data-mp="3dp4bboiuwvgq">
          <h3 className="text-2xl font-bold text-[#1a2b4a] mb-6" data-id="element-2184" data-mp="1gvsnxfyo2eu1">
            Herken jij dit bij jouw hond?
          </h3>
          <ul className="space-y-4" data-id="element-2185" data-mp="1bw7n0zzxrweo">
            {['Springt tegen visite op, blaft de bezorger af, of wordt helemaal gek als er iemand aan de deur komt', 'Trekt als een bezetene aan de lijn of valt uit naar andere honden tijdens het wandelen', 'Pakt eten van tafel, luistert niet als je hem roept, of negeert je compleet in het park', 'Is constant druk in huis, kan niet tot rust komen op zijn plek, of volgt je overal naartoe', 'Reageert angstig op geluiden, nieuwe plekken of onbekende mensen - en jij weet niet hoe je hem gerust kunt stellen', 'Het gevoel dat je alles al hebt geprobeerd, maar dat jullie nog steeds langs elkaar heen leven', 'Hij vertrouwt je niet echt'].map((item, i) => <li key={i} className="flex items-start" data-id="element-2186" data-mp="1fex0tu3iozjp" data-mpi={i}>
                <Check className="w-6 h-6 text-[#5ce0d2] mr-3 flex-shrink-0 mt-0.5" data-id="element-2187" data-mp="1fcan1cq19nt1" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-2188" data-mp="2lwtm4zqbqy34">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-lg font-bold text-[#1a2b4a]" data-id="element-2189" data-mp="qqhqjcv3drub">
            Dan is deze cursus voor jou.
          </p>
        </div>
      </section>

      {/* 9. FULL WIDTH PRICING CTA */}
      <section className="bg-white py-16 border-y border-gray-200" data-id="element-2190" data-mp="zsiqwilmgu07">
        <div className="max-w-4xl mx-auto px-4" data-id="element-2191" data-mp="vqno19o1m8kb">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-2192" data-mp="vryq951ub89b">
            <div data-id="element-2193" data-mp="80jn5a28omx0">
              <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-2194" data-mp="824giwcthzta">
                Liefdevol Communiceren
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] mb-4" data-id="element-2195" data-mp="305fvu8gph01">
                Pakket Actie
              </h2>
              <div className="text-gray-500 text-base mb-1" data-id="element-2196" data-mp="c2emi90m0q85">
                Totale waarde: <span className="line-through" data-id="element-2197" data-mp="3kigdya7i6wxr">€401</span>
              </div>
              <div className="text-[#e53e3e] font-black text-4xl mb-1" data-id="element-2198" data-mp="3kgdg5403zzih">
                Nu voor €127
              </div>
              <div className="text-[#e53e3e] font-bold text-lg mb-4" data-id="element-2199" data-mp="36cxxowodexqe">
                (Bespaar €274)
              </div>
              <p className="text-gray-600 mb-6" data-id="element-2200" data-mp="3b3wj2ao7um0i">
                Start met het Liefdevol Communiceren Pakket voor €127. Inclusief
                2 gratis aanvullende cursussen naar keuze en het digitale boek
                "Wat Zegt Jouw Hond?". Per direct toegang.
              </p>
            </div>
            <div data-id="element-2201" data-mp="3p360tes2lo6l">
              <CTAButton data-id="element-2202" data-mp="3p4qsmwn02t0r" />
              <div className="text-xs text-gray-500 space-y-2 mt-4 text-center" data-id="element-2203" data-mp="3p1cpvnafchss">
                <p className="flex items-center justify-center gap-1" data-id="element-2204" data-mp="3u20gw8ynkyn0">
                  <Lock className="w-4 h-4" data-id="element-2205" data-mp="3f61dhbmhnmo7" /> 100% veilig afrekenen
                </p>
                <p className="flex items-center justify-center gap-1" data-id="element-2206" data-mp="3k3tb8m9te30b">
                  <ShieldCheck className="w-4 h-4" data-id="element-2207" data-mp="3k65q2qk9zx95" /> Met onze 100% geld terug
                  garantie
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PakketActieSection data-id="element-2208" data-mp="2owbzpdk8kwtx" />

      {/* 10. DETAILED EXPLANATION + SIDEBAR */}
      <section className="max-w-7xl mx-auto px-4 py-16" data-id="element-2209" data-mp="2oyex4inpxs8o">
        <div className="grid lg:grid-cols-12 gap-8" data-id="element-2210" data-mp="2k4kgxp7bnvec">
          {/* Left column - main content */}
          <div className="lg:col-span-8" data-id="element-2211" data-mp="2f7kc1hm7kyot">
            <h2 className="text-3xl font-bold text-[#5ce0d2] mb-6" data-id="element-2212" data-mp="2f4enq4lem0u5">
              Hij luistert wel, maar begrijpt je niet
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed mb-12 space-y-4" data-id="element-2213" data-mp="37vpw025fujnl">
              <p data-id="element-2214" data-mp="32wczeporly7t">
                Een commando heeft pas zin als je eerst dezelfde taal spreekt
                als je hond.
              </p>
              <p data-id="element-2215" data-mp="2xvp780osvbc0">
                Doe je dat niet, dan blijft er een onzichtbare muur tussen
                jullie staan. Je hond snapt niet wat je tegen hem zegt, en jij
                begrijpt niet waarom. Want jullie spreken letterlijk een andere
                taal.
              </p>
              <p data-id="element-2216" data-mp="1hhpfve40su0d">
                Jouw hond communiceert de hele dag subtiele signalen. Dat je die
                soms mist, is niet jouw schuld. De ouderwetse hondenindustrie
                heeft ons decennialang verteld dat honden gewoon moeten
                'luisteren', in plaats van ons te leren hoe we hun taal kunnen
                lezen.
              </p>
              <p data-id="element-2217" data-mp="bpcenjpv2xff">
                Oude trainingsmethodes laten je geloven dat je hond 'koppig' of
                'dominant' is als die niet luistert, terwijl jullie in
                werkelijkheid elkaar niet begrijpen. Zodra je weet hoe je op een
                manier communiceert die hij vanuit zijn natuur snapt, valt die
                frustratie direct weg.
              </p>
              <p className="font-medium" data-id="element-2218" data-mp="uogfw6b5vmwj">
                Daarom moet je eerst de taalbarrière doorbreken. Dit is hoe het
                werkt.
              </p>
            </div>

            {/* 11. 3 STEPS */}
            <div className="mb-8 rounded-xl overflow-hidden" data-id="element-2219" data-mp="2wfbgdbgbca9l">
              <img src="https://cdn.magicpatterns.com/uploads/43tvVR32w9VpvEgS87mE9U/liefdevol_vergelijking_v4.png" alt="Oude Aanpak vs De Liefdevol Communiceren Methode" className="w-1/2 h-auto object-contain rounded-lg mx-auto" data-id="element-2220" data-mp="2whxopdb12tsv" />
            </div>
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-8 text-center" data-id="element-2221" data-mp="2yays86f0i8bm">
              De taalbarrière doorbreken in drie stappen
            </h2>
            <div className="space-y-8 mb-16" data-id="element-2222" data-mp="37cote3yp4lml">
              {[{
              title: 'Stap 1: Hondentaal',
              text: 'De eerste stap is de taal van je hond leren. Je hond communiceert de hele dag via subtiele lichaamssignalen. In stap 1 leer je deze signalen herkennen en begrijpen, zodat je eindelijk weet wat je hond je probeert te vertellen.'
            }, {
              title: 'Stap 2: Terugpraten',
              text: 'De tweede stap is zelf in die taal terugpraten. Je leert hoe je met handgebaren en lichaamstaal signalen communiceert op een manier die je hond van nature begrijpt. Geen geschreeuw, geen straffen - gewoon duidelijke, liefdevolle communicatie die hij meteen oppikt.'
            }, {
              title: 'Stap 3: Samenwerken',
              text: 'En dan, als jullie dezelfde taal spreken… Ga je als derde stap écht samenwerken. Niet meer commanderen en gehoorzamen, maar een gelijkwaardige samenwerking gebaseerd op begrip en vertrouwen. Gedragsproblemen lossen zichzelf op, want de oorzaak - miscommunicatie - is verdwenen.'
            }].map((step, i) => <div key={i} className="flex gap-6 items-start" data-id="element-2223" data-mp="3d1bln8imf9x9" data-mpi={i}>
                  <div className="w-12 h-12 rounded-full bg-[#5ce0d2] text-white flex items-center justify-center font-bold text-2xl flex-shrink-0 mt-1" data-id="element-2224" data-mp="3hylhp70imju2">
                    {i + 1}
                  </div>
                  <div data-id="element-2225" data-mp="3816zb1v17kz4">
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-2226" data-mp="37zm89m7xek60">
                      {step.text}
                    </p>
                  </div>
                </div>)}
            </div>
            <p className="text-lg text-gray-700 leading-relaxed mb-4 font-medium" data-id="element-2227" data-mp="3jhv8cy14jztw">
              Op deze manier kan zelfs een hond die al jaren uitvalt, blaft of
              trekt leren om rustig en ontspannen te zijn - omdat hij zich
              eindelijk begrepen voelt en jij eindelijk begrijpt wat hij nodig
              heeft.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-8 font-medium" data-id="element-2228" data-mp="2zsui96iihk0y">
              Zonder frustratie, zonder straffen, zonder dominantie.
            </p>

            {/* 13. ZO PAS JE HET TOE */}
            <h2 className="text-3xl font-bold text-[#1a2b4a] mb-6" data-id="element-2229" data-mp="2qth7mainipen">
              Zo pas je de Liefdevol Communiceren Methode vandaag nog toe
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-2230" data-mp="2lvfm7ixr6e00">
              De Liefdevol Communiceren Methode is uniek in Nederland.
              Hondenscholen werken nog niet op deze manier. Maar wij vinden dat
              ieder hondenbaasje dat worstelt met de gedragsproblemen van zijn
              hond, of die zijn hond simpelweg beter wilt begrijpen, de kans zou
              moeten krijgen om hiermee aan de slag te gaan.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-2231" data-mp="2lmj4limb87o4">
              Daarom hebben we een videotraining gemaakt voor je. In deze
              training doorlopen we de drie essentiële stappen in deze aanpak.
              Dit doen we met een rustige uitleg, praktijkvoorbeelden en
              printbaar lesmateriaal.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-2232" data-mp="22ozu0ak7egzl">
              {[{
              title: 'Stap 1',
              text: 'Na stap 1 begrijp je de subtiele lichaamssignalen van je hond en hoe je deze leest, zodat je zeker weet wat hij je probeert te vertellen.'
            }, {
              title: 'Stap 2',
              text: 'Na stap 2 snap je hoe je met handgebaren en je lichaam in hondentaal terugpraat, zodat je hond jou begrijpt en klaar is voor stap 3.'
            }, {
              title: 'Stap 3',
              text: 'En na stap 3 snap je hoe jullie als een team kunnen samenwerken, zodat gedragsproblemen vanzelf verdwijnen.'
            }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-t-4 border-[#5ce0d2]" data-id="element-2233" data-mp="4ii4ag8g4ohi" data-mpi={i}>
                  <h4 className="font-bold text-xl text-[#1a2b4a] mb-3" data-id="element-2234" data-mp="3m0jhfn1aunge">
                    {les.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-2235" data-mp="3qvypfycmlp4w">
                    {les.text}
                  </p>
                </div>)}
            </div>
            <p className="text-center font-bold text-gray-500 mb-16" data-id="element-2236" data-mp="3gzdjnass8a00">
              Zet vandaag nog de eerste stap.
            </p>
          </div>

          {/* Right column - sticky sidebar */}
          <div className="hidden lg:block lg:col-span-4" data-id="element-2237" data-mp="2te2z975l65po">
            <div className="sticky top-8" data-id="element-2238" data-mp="37csxwr820dg5">
              <div className="bg-white rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-2239" data-mp="37dkspzttu75d">
                {/* BIJ JE BESTELLING */}
                <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-black text-sm uppercase tracking-widest" data-id="element-2240" data-mp="3ha7csmebwu6c">
                  BIJ JE BESTELLING
                </div>

                <div className="p-5" data-id="element-2241" data-mp="3q2rejvpx3eve">
                  {/* Product */}
                  <div className="flex gap-4 items-start mb-6" data-id="element-2242" data-mp="3q1zh0fcrf72h">
                    <img src="https://cdn.magicpatterns.com/uploads/4wUNXnqn4DFV4J3eFkdeE5/lc_book_mockup.png" alt="Liefdevol Communiceren - Cursus" className="w-20 h-20 object-cover rounded-lg flex-shrink-0" data-id="element-2243" data-mp="3m28kdv0jxwq1" />
                    <div data-id="element-2244" data-mp="2sp8xcjcllrmw">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-2245" data-mp="2sq0sjt2a9ncn">
                        LIEFDEVOL COMMUNICEREN - CURSUS
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-2246" data-mp="31o2ymn0vj66s">
                        Gedetailleerde uitleg van hoe je de verborgen
                        taalbarrière in 3 stappen doorbreekt en een diepe band
                        opbouwt
                      </p>
                    </div>
                  </div>

                  {/* 5 FREE FAST ACTION BONUSES */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-5" data-id="element-2247" data-mp="3kf3swxr1udk0">
                    3 x GRATIS BONUS
                  </div>

                  {/* Bonus 1 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-2248" data-mp="1q35p5bbie9vi">
                    <img src="https://cdn.magicpatterns.com/uploads/kK8kyQqoZHm31F5VUdBjhD/2.png" alt="30 Dagen Community Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-2249" data-mp="1uzw2hqvxird8" />
                    <div data-id="element-2250" data-mp="1dr3iff9v654e">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-2251" data-mp="1dseo5kmvdmy5">
                        30 DAGEN COMMUNITY TOEGANG
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-2252" data-mp="26fscwvgezc76">
                        Stuur vragen, foto's en videos naar onze experts, neem
                        deel aan meerdere wekelijkse online coachingsessies en
                        kom in contact met andere hondenbaasjes.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 2 */}
                  <div className="flex gap-3 items-start mb-5" data-id="element-2253" data-mp="l37d5m68b4w0">
                    <img src="https://cdn.magicpatterns.com/uploads/jpptdiaLg8Jy3uMEh1EZiz/3.png" alt="Printbare Stappenplannen" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-2254" data-mp="l0l75qyzkxfw" />
                    <div data-id="element-2255" data-mp="29q3ai4rljbtc">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-2256" data-mp="29qbra7qub19t">
                        Printbare Stappenplannen
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-2257" data-mp="1zz8p12m6cg8y">
                        Handige, printbare overzichten van alle lichaamssignalen
                        en kalmerende signalen om er altijd bij te kunnen
                        pakken.
                      </p>
                    </div>
                  </div>

                  {/* Bonus 3 */}
                  <div className="flex gap-3 items-start mb-6" data-id="element-2258" data-mp="2iofagxecrlyg">
                    <img src="https://cdn.magicpatterns.com/uploads/bbcA4WNP4wTigQiHJcajRX/4.png" alt="Levenslange Toegang" className="w-16 h-16 object-cover rounded-lg flex-shrink-0" data-id="element-2259" data-mp="138g7e0jleg52" />
                    <div data-id="element-2260" data-mp="zoo5f6a2pont">
                      <h4 className="text-[#1a2b4a] font-bold text-sm leading-tight mb-1" data-id="element-2261" data-mp="urfwzxeq8yzr">
                        Levenslange Toegang
                      </h4>
                      <p className="text-gray-500 text-xs leading-relaxed" data-id="element-2262" data-mp="19o6ntiac52dr">
                        Je krijgt levenslange toegang tot al het lesmateriaal,
                        inclusief alle toekomstige updates van de cursus.
                      </p>
                    </div>
                  </div>

                  {/* RESULTATEN */}
                  <div className="bg-[#1a2b4a] text-white text-center py-2 px-3 font-black text-xs uppercase tracking-widest rounded-md mb-4" data-id="element-2263" data-mp="qpucpqzv5ifj">
                    RESULTATEN VAN DE METHODE
                  </div>

                  {/* Vimeo video */}
                  <div className="rounded-lg overflow-hidden" data-id="element-2264" data-mp="3udmi4n8rj985">
                    <div style={{
                    padding: '112.5% 0 0 0',
                    position: 'relative'
                  }} data-id="element-2265" data-mp="3pgcoeveccbei">
                      <iframe src="https://player.vimeo.com/video/1084988962?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%'
                    }} title="Resultaten video" data-id="element-2266" data-mp="mznw5j7stugp"></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16. LETTER SECTION */}
      <section className="bg-white py-16" data-id="element-2267" data-mp="1peo9ds2ozfaf">
        <div className="max-w-6xl mx-auto px-4" data-id="element-2268" data-mp="1pdd2hjdy9rf3">
          {/* Section headline */}
          <h2 className="text-3xl md:text-4xl font-black text-[#1a2b4a] text-center mb-4" data-id="element-2269" data-mp="39wys5jk9z3bl">
            RESULTATEN VAN DE METHODE
          </h2>
          <p className="text-center text-lg text-gray-700 max-w-3xl mx-auto mb-8" data-id="element-2270" data-mp="34zp1k0l5glm6">
            Dit is hoe ik hondenbaasjes help om de taalbarrière te doorbreken
            door eerst de hondentaal te leren, dit maakt de verdere samenwerking
            veel en veel makkelijker
          </p>

          <p className="text-xl font-bold text-[#5ce0d2] mb-12 text-center leading-relaxed max-w-3xl mx-auto" data-id="element-2271" data-mp="2r7ik8b69g8l5">
            Deze aanpak is nieuw, compleet anders, en verschilt van de eerdere
            aanpakken die je tot nu toe kent - lees mijn verhaal hieronder over
            het ontstaan van de Liefdevol Communiceren Methode
          </p>

          <div className="grid lg:grid-cols-12 gap-8" data-id="element-2272" data-mp="fh6hkyl2fpgv">
            {/* Left column - letter content */}
            <div className="lg:col-span-8" data-id="element-2273" data-mp="ahbvd8c8jo25">
              <div className="bg-[#faf5eb] rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100" data-id="element-2274" data-mp="afh7bl5o3ftu">
                <div className="prose prose-lg max-w-none text-gray-800" data-id="element-2275" data-mp="3fjosmgiohwce">
                  <p className="font-bold" data-id="element-2276" data-mp="3kg6vfaug7km3">Beste hondenbaasje,</p>
                  <p data-id="element-2277" data-mp="36ptp1cx7gdyv">
                    <strong data-id="element-2278" data-mp="36oik39s0x066">Van:</strong> Amee de Bruijn
                  </p>
                  <p data-id="element-2279" data-mp="3aqdmyiplrlm2">
                    <strong data-id="element-2280" data-mp="3apklnx9exobb">Re:</strong> De enige manier om gedragsproblemen
                    écht op te lossen, is door de taal van je hond te spreken
                    (en niet door te commanderen).
                  </p>
                  <p data-id="element-2281" data-mp="31o4ahnarxi61">
                    Misschien verbaast het je dat er een andere manier is dan
                    eindeloos corrigeren waarmee je gedragsproblemen sneller
                    kunt oplossen, met een minimale kans op terugval.
                  </p>
                  <p data-id="element-2282" data-mp="m0e1qrx737dz">En dat is niet gek.</p>
                  <p data-id="element-2283" data-mp="lx8d1dsha7is">
                    Want bijna alles wat je online vindt, draait om
                    symptoombestrijding: commando's, correcties, je hond
                    domineren, of afleiden met snoepjes.
                  </p>
                  <p data-id="element-2284" data-mp="26hwqhd0tx5qz">
                    Geen van deze methodes focust zich op het échte,
                    onderliggende probleem.
                  </p>
                  <p data-id="element-2285" data-mp="2kacxeowupnx6">
                    Waarom zou mijn verhaal dan wel waar zijn? Je kunt immers
                    niet alles geloven wat je op het internet leest.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] mt-8" data-id="element-2286" data-mp="2u8sk8fouib0v">
                    Dus laat het me je bewijzen.
                  </p>
                  <div className="bg-white p-6 rounded-lg my-8 text-sm italic text-gray-600 border-l-4 border-gray-300" data-id="element-2287" data-mp="337mew0im8rbs">
                    <strong data-id="element-2288" data-mp="2y9kvfeha2pzs">Maar lees eerst deze disclaimer:</strong> Ik heb het
                    voordeel van jarenlange ervaring en het doorbreken van oude
                    methodes. De gemiddelde persoon die een "zo-doe-je-dat"
                    methode volgt, behaalt weinig tot geen resultaten. Jouw
                    resultaten zijn afhankelijk van vele factoren, waaronder
                    vooral je bereidheid om te doen wat er in de methode staat.
                    Deze verandering vraagt erom dat je anders gaat kijken naar
                    je hond. Op een lievere, empatischere manier waarin je hond
                    geen robot is die zomaar bevelen op zou moeten volgen. Maar
                    meer een volwaardig gezinslid van een gezin waar jij aan het
                    hoofd staat. Als je er niet toe bereid bent zo naar je hond
                    te kijken, dan is deze methode misschien niet voor jou. Met
                    dat gezegd, laat me je laten zien hoe het anders kan.
                  </div>

                  <p className="font-bold text-2xl text-[#1a2b4a] mt-12 mb-6" data-id="element-2289" data-mp="lq60y0zo615r">
                    Ik werk met een compleet andere methode die ik nu met jou ga
                    delen.
                  </p>
                  <p data-id="element-2290" data-mp="10d4q1pb20jhb">
                    Dit is dezelfde Liefdevol Communiceren Methode die duizenden
                    hondeneigenaren nu gebruiken om onbegrip, irritaties en
                    problemen met hun hond écht op te lossen.
                  </p>
                  <p data-id="element-2291" data-mp="qefe0d5u9t8z">
                    Hierdoor krijgen zij een ontspannen hond terug, sneller dan
                    ze ooit voor mogelijk hielden.
                  </p>
                  <p data-id="element-2292" data-mp="hllo7lsrnbgv">
                    En het mooiste van alles? Ze bouwen een diepere, betere band
                    op met hun hond, gebaseerd op begrip in plaats van
                    frustratie.
                  </p>
                  <p className="font-bold" data-id="element-2293" data-mp="7m35t9si7xqx">
                    Dit is niet zomaar een stappenplan;
                  </p>
                  <p data-id="element-2294" data-mp="3usvoohx2v1j4">
                    Het is een fundamenteel andere manier van samenleven met je
                    hond. We focussen ons niet op:
                  </p>
                  <ul className="list-disc pl-6 mb-6 space-y-2" data-id="element-2295" data-mp="2r7bg2zsoyan">
                    <li data-id="element-2296" data-mp="25ctedxirhtea">
                      Eindeloze gehoorzaamheidstrainingen die nergens toe
                      leiden.
                    </li>
                    <li data-id="element-2297" data-mp="1vlyjy5vd3nhr">
                      Je hond straffen of corrigeren als hij iets 'fout' doet.
                    </li>
                    <li data-id="element-2298" data-mp="1qnna3v52hczj">Trucjes om je hond af te leiden met voer.</li>
                    <li data-id="element-2299" data-mp="2oam766zo8mxy">
                      Standaard protocollen die geen rekening houden met jouw
                      unieke hond.
                    </li>
                  </ul>
                  <p className="font-bold text-xl text-[#5ce0d2] p-6 bg-[#e6f7f5] rounded-lg my-8" data-id="element-2300" data-mp="2j9q6016pfew8">
                    In plaats daarvan doen we iets wat bijna niemand doet: we
                    beginnen met het leren van de taal van de hond zodat jullie
                    elkaar echt gaan begrijpen.
                  </p>
                  <p data-id="element-2301" data-mp="yv6ctxqep5s4">
                    Dit is een compleet andere aanpak, en het heeft de kracht om
                    alles voor jou en je hond te veranderen. Ik weet dat dit
                    waar is, want het heeft alles voor mij veranderd.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-2302" data-mp="3eia76mel1xna">
                    Hoe ik dit ontdekte: De "Muur van Onbegrip" bij mijn klanten
                  </h3>
                  <p data-id="element-2303" data-mp="3obr624tku2xt">
                    Als gedragsdeskundige zag ik dit patroon steeds terugkomen
                    bij mijn klanten. Ik noem het de "Muur van Onbegrip":
                  </p>
                  <div className="bg-white border border-gray-200 rounded-lg p-6 my-6 space-y-3 shadow-sm" data-id="element-2304" data-mp="21eszv5zgi6d">
                    <p data-id="element-2305" data-mp="62qhfxd4excz">
                      <strong data-id="element-2306" data-mp="b3o16eds3zgl">Stap 1:</strong> Ze volgden online adviezen en
                      begonnen met strenge commando's en correcties.
                    </p>
                    <p data-id="element-2307" data-mp="27yap8dw4b7q6">
                      <strong data-id="element-2308" data-mp="2cvarsetrdscj">Stap 2:</strong> De hond luisterde niet, dus ze
                      proberen strenger te zijn. Meer correcties.
                    </p>
                    <p data-id="element-2309" data-mp="1hj9pixole873">
                      <strong data-id="element-2310" data-mp="1cm1gbmlf9ehz">Stap 3:</strong> Na een week leek de hond even te
                      luisteren uit angst. Een klein succes!
                    </p>
                    <p data-id="element-2311" data-mp="1ris6r6d4bfvg">
                      <strong data-id="element-2312" data-mp="1rgxvykvk9453">Stap 4:</strong> Maar het streng zijn voelt niet
                      fijn voor het baasje en is niet altijd consistent. Wat
                      weer verwarrend is voor de hond.
                    </p>
                    <p data-id="element-2313" data-mp="tw1tz7gyudi9">
                      <strong data-id="element-2314" data-mp="twusxm9onypu">Stap 5:</strong> De hond onderdrukt deels zijn
                      reacties en de hele situatie levert hem stress op.
                    </p>
                    <p data-id="element-2315" data-mp="13t660eh3kslc">
                      <strong data-id="element-2316" data-mp="13sxtwosstrb7">Stap 6:</strong> Stress bij de hond bouwt op
                      waardoor hij reactief wordt. Hij reageert ineens heftig op
                      straat, wordt angstig of gaat ander "probleemgedrag"
                      vertonen.
                    </p>
                    <p data-id="element-2317" data-mp="2ms42cz2uxqb7">
                      <strong data-id="element-2318" data-mp="2mqt2398mf0ou">Stap 7:</strong> Met dit nieuwe gedrag beginnen ze
                      weer bij stap 1 (en voelen zich een slechte baas).
                    </p>
                  </div>
                  <p data-id="element-2319" data-mp="2cvspo7zcuyg8">
                    Ik zag hoe deze cirkel mijn klanten jarenlang gevangen
                    hield. Ze voelden zich machteloos en schuldig.
                  </p>
                  <p data-id="element-2320" data-mp="35jwvcthxfbix">
                    Ik voelde me gefrustreerd omdat ik zag dat ik hen niet echt
                    hielp. Ik was aan het symptoombestrijden, niet aan het
                    oplossen en het voelde slecht.
                  </p>
                  <p data-id="element-2321" data-mp="30jsfn5ouektr">
                    Ik stond op het punt om te geloven dat sommige honden gewoon
                    onhandelbaar waren en het vak als hondengedragsdeskundige
                    niks voor mij was.
                  </p>
                  <p data-id="element-2322" data-mp="1p5om20m62yp8">
                    Maar voordat ik opgaf, kwam ik in aanraking met een nieuwe
                    methode. En deze methode veranderde alles voor mij.
                  </p>

                  <div className="my-12 flex flex-col md:flex-row gap-8 items-center" data-id="element-2323" data-mp="3mt8y4o1guq6u">
                    <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee de Bruijn" className="w-48 h-48 rounded-full object-cover shadow-xl border-4 border-white" data-id="element-2324" data-mp="3i0zf7ryrqqe2" />
                    <div data-id="element-2325" data-mp="340oii8as2hkz">
                      <h3 className="text-2xl font-bold text-[#1a2b4a] mb-4" data-id="element-2326" data-mp="340eu2p5dsihe">
                        Mijn naam is Amee, en ik ken de frustratie als baasje.
                      </h3>
                      <div className="space-y-4" data-id="element-2327" data-mp="2u53clz2l8x5y">
                        <p className="text-sm text-[#5ce0d2] font-bold uppercase tracking-wide" data-id="element-2328" data-mp="xb081kpjslci">
                          Gediplomeerd Hondengedragsconsultant & Natural Dog
                          Trainer (niveau 5, Calming Signs, 2017)
                        </p>
                        <p data-id="element-2329" data-mp="10r3eaf68n8zb">
                          Als gedragsdeskundige zag ik steeds dezelfde pijn.
                          Honden die ondanks alle liefde die ze van hun baasje
                          krijgen nog steeds problemen hebben.
                        </p>
                        <p data-id="element-2330" data-mp="1ej9kb8fofzl1">
                          Eigenaren die alles voor hun hond over hebben, maar
                          waarvan de hond nog steeds niet altijd lekker in zijn
                          vel zit.
                        </p>
                        <p data-id="element-2331" data-mp="qv020gho9tyn">
                          Geen ontspannen wandeling, altijd die knoop in je maag
                          als je een andere hond tegenkomt, reactieve hond die
                          reageert op alles buiten het huis, heftige reactie op
                          visite, en nog meer...
                        </p>
                        <p data-id="element-2332" data-mp="277ylt8kna6xb">
                          Na jarenlange ervaring met honderden honden en hun
                          baasjes, en een specialisatie in natuurlijk
                          hondengedrag en hondenlichaamstaal, ontwikkelde ik een
                          methode die niet draait om gehoorzaamheid, maar om
                          wederzijds begrip.
                        </p>
                      </div>
                    </div>
                  </div>

                  <p data-id="element-2333" data-mp="3c0i7km396bxa">
                    Keer op keer zag ik dat de standaard aanpak niet echt hielp.
                  </p>
                  <p data-id="element-2334" data-mp="371osip8bicv0">
                    Het keerpunt kwam bij een klant met een hond die meerdere
                    problemen had. We kregen het gedrag niet opgelost met de
                    standaard aanpak die ik toen ook nog toepaste.
                  </p>
                  <p data-id="element-2335" data-mp="1qnf7a3zdh48e">
                    Pas toen we alles loslieten, volledig stopten met
                    conditioneren en begonnen met het echt kijken naar zijn
                    signalen en wat hij nodig had - gebeurde er iets magisch.
                    Het probleemgedrag verdween daarna als sneeuw voor de zon.
                  </p>
                  <p data-id="element-2336" data-mp="654k80arau1f">
                    Het was een Eureka-moment. Ineens viel alles op zijn plek.
                  </p>
                  <p className="font-bold text-xl text-[#1a2b4a] my-6" data-id="element-2337" data-mp="3slh8dl5n59k4">
                    Ongehoorzaamheid was niet het probleem; het was een
                    symptoom.
                  </p>
                  <p data-id="element-2338" data-mp="3eo2bxwgz01in">En die kijk maakt het verschil in alles dat ik doe.</p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-2339" data-mp="3jm3y4q9p0gyc">
                    De #1 Fout die iedereen maakt: focussen op het symptoom
                  </h3>
                  <p data-id="element-2340" data-mp="39neeary8kmfg">
                    De markt voor hondentraining is verdeeld in twee kampen. Je
                    hebt de "africhters" en je hebt de "liefdevolle
                    hondenouders". Wij van Stressless Dogs zijn dat laatste. Wij
                    geloven dat je als hondenbaasje eigenlijk geen echte "baas"
                    bent over je hond, maar meer een liefdevolle ouder.
                  </p>
                  <p data-id="element-2341" data-mp="2fhe3qgnhgv1d">
                    Maar jarenlang was ik ook een africhter. Ik probeerde mijn
                    klanten te helpen door het blaffen, piepen en slopen af te
                    leren...
                  </p>
                  <p data-id="element-2342" data-mp="2tb5chmte4aw1">
                    Alleen het probleem is niet het gedrag zelf. Het probleem is
                    waar het gedrag vandaan komt.
                  </p>
                  <p className="font-bold text-red-600" data-id="element-2343" data-mp="2ybt347dpippq">
                    Het gevaarlijkste advies dat je kunt krijgen, is "strenger
                    en consistent zijn".
                  </p>
                  <p data-id="element-2344" data-mp="378bu3e2do3jo">
                    Waarom? Omdat honden wel willen samenwerken, maar vaak niet
                    snappen wat van hen verwacht wordt omdat het baasje
                    verkeerde signalen met zijn lichaam afgeeft.
                  </p>
                  <p data-id="element-2345" data-mp="15dw7uvwzhaq2">Door deze miscommunicatie krijgt de hond stress.</p>
                  <p data-id="element-2346" data-mp="10lvzqg6rfbie">
                    En deze stress bouwt op en zorgt voor meer probleemgedrag.
                  </p>
                  <p data-id="element-2347" data-mp="vo49rrpodzgu">
                    Opgebouwde stress zorgt ervoor dat je hond reactief wordt,
                    sneller blaft naar voorbijgangers, aan de lijn gaat trekken,
                    uitvalt, en meer.
                  </p>
                  <p className="font-bold" data-id="element-2348" data-mp="1o9mbsooh8h6l">
                    Daarom is de oplossing anders dan je denkt.
                  </p>
                  <p className="font-bold" data-id="element-2349" data-mp="1fasgr2qsnyv5">
                    Zodra je de lichaamssignalen van je hond goed begrijpt zie
                    je wat hij denkt, wilt en waar hij stress van krijgt. En als
                    je terug communiceert op een manier die hij van nature
                    begrijpt. Dan raakt je hond veel meer op zijn gemak en zal
                    je zien dat hij naar je luistert.
                  </p>

                  <h3 className="text-2xl font-black text-[#1a2b4a] mt-12 mb-8" data-id="element-2350" data-mp="eqwrr3ze10s">
                    Wat je leert in deze training:
                  </h3>
                  <div className="space-y-6 not-prose" data-id="element-2351" data-mp="3nj71kx5x3el7">
                    {[{
                    title: 'Stap 1: Hondentaal',
                    text: 'Leer de subtiele lichaamssignalen van je hond en hoe je ontdekt wat hij je precies probeert te vertellen.'
                  }, {
                    title: 'Stap 2: Terugpraten',
                    text: 'Krijg de tools om in zijn eigen taal terug te communiceren en een sterke, veerkrachtige vertrouwensband te leggen.'
                  }, {
                    title: 'Stap 3: Samenwerken',
                    text: 'Leer hoe je stressvrij en effectief kunt samenwerken, op een manier die past bij jouw hond, zodat je snel en blijvend resultaat boekt.'
                  }].map((les, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 flex gap-4 items-start" data-id="element-2352" data-mp="2b8g4djtxsana" data-mpi={i}>
                        <PlayCircle className="w-8 h-8 text-[#5ce0d2] flex-shrink-0 mt-1" data-id="element-2353" data-mp="2l6nhtsp0oakj" />
                        <div data-id="element-2354" data-mp="2l9094wgnzxa9">
                          <h4 className="font-bold text-xl text-[#1a2b4a] mb-2" data-id="element-2355" data-mp="2z5vnn4foqgxp">
                            {les.title}
                          </h4>
                          <p className="text-gray-700 m-0" data-id="element-2356" data-mp="2u57vugjmtw2f">{les.text}</p>
                        </div>
                      </div>)}
                  </div>
                  <p className="text-gray-600 mt-8 italic" data-id="element-2357" data-mp="33ygatn435vs9">
                    Daarnaast krijg je toegang tot casestudies en interviews met
                    klanten, zodat je precies ziet hoe deze aanpak in de
                    praktijk werkt.
                  </p>

                  <h3 className="text-2xl font-bold text-[#1a2b4a] mt-12 mb-6" data-id="element-2358" data-mp="1b9fo7a2l9y7r">
                    Voor wie is deze methode (niet)?
                  </h3>
                  <p data-id="element-2359" data-mp="1g5miu6pjbnae">
                    Deze methode is <strong data-id="element-2360" data-mp="1kxxm9jjhhr7p">niet</strong> voor mensen die hun
                    hond zien als een robot die moet gehoorzamen. Het is niet
                    voor mensen die een snelle, magische oplossing zoeken zonder
                    bereid te zijn hun hond echt te begrijpen.
                  </p>
                  <p data-id="element-2361" data-mp="x838mzrcbyme">
                    Deze methode is <strong data-id="element-2362" data-mp="x94wy5xdahm2">voor jou</strong> als je je hond
                    ziet als een volwaardig gezinslid. Als je gelooft dat hij
                    emoties en gevoelens heeft die gerespecteerd moeten worden.
                    En als je bereid bent om het anders te doen, op een manier
                    die op de lange termijn beter is voor zowel jou als je hond.
                  </p>
                  <p className="text-xl font-bold text-[#5ce0d2] mt-8 mb-12" data-id="element-2363" data-mp="2hmvfuyfhzj3a">
                    Als je klaar bent om de cirkel van stress te doorbreken en
                    een diepere band met je hond te krijgen, dan is dit het
                    moment.
                  </p>

                  <div className="rounded-xl overflow-hidden shadow-lg mt-8" data-id="element-2364" data-mp="2i1it3gatbvez">
                    <img src="https://cdn.magicpatterns.com/uploads/7QbopuV5o2pEQqFw8GzzYw/Ontwerp_zonder_titel_(66).png" alt="Amee met hond buiten" className="w-full h-auto object-cover" data-id="element-2365" data-mp="2e21n8lrh4w9a" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - sticky sidebar */}
            <div className="lg:col-span-4" data-id="element-2366" data-mp="1v3fld4o4v14b">
              <div className="lg:sticky lg:top-8 space-y-6" data-id="element-2367" data-mp="1v4qpj5lhqavy">
                {/* Product image */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2368" data-mp="3tfo24npvuvh6">
                  <img src="https://cdn.magicpatterns.com/uploads/7kNRQ43TgkEzcEQikb1C2w/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training op verschillende apparaten" className="w-full h-auto object-contain" data-id="element-2369" data-mp="3peknu5nhh7i2" />
                </div>

                {/* Wat je krijgt */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2370" data-mp="1hv6ob3sxg23w">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2371" data-mp="25krcq27unrkk">
                    Dit is wat je krijgt met de training
                  </div>
                  <div className="p-5 space-y-5" data-id="element-2372" data-mp="1wirrexpsy1bt">
                    <div className="flex items-start gap-3" data-id="element-2373" data-mp="21imj33heiuxx">
                      <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2374" data-mp="21h32fbru2hvm" />
                      <span className="text-sm font-bold text-gray-800" data-id="element-2375" data-mp="l3l9nsh6uqv2">
                        Drie stappen kernaanpak om jouw hond te leren alleen
                        thuis te blijven
                      </span>
                    </div>

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2376" data-mp="dkvilh28vikk">
                      Dit leer je in Stap 1
                    </p>
                    {['Hoezo commanderen geen nut heeft als je niet eerst dezelfde taal spreekt', 'Welke subtiele lichaamssignalen honden gebruiken en wat ze precies betekenen', 'Hoe je de signalen van jouw hond leest zodat je weet wat hij nodig heeft'].map((item, i) => <div key={`l1-${i}`} className="flex items-start gap-3" data-id="element-2377" data-mp="8lsb7pysl09f" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2378" data-mp="8nvaz1pqy7rc" />
                        <span className="text-sm text-gray-700" data-id="element-2379" data-mp="3tr2uf4qvtoo">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2380" data-mp="37bsi39cjk6ov">
                      Dit leer je in Stap 2
                    </p>
                    {['Hoe je kalmerende signalen en handgebaren gebruikt om terug te praten', 'Wat je wel, en wat je juist niet moet doen met je lichaamstaal om misverstanden te voorkomen', 'Voorbeeld casus van hond Lemmy en hoe hij van extreem uitvallen naar ontspannen wandelen ging met deze methode', 'Voorbeeld casus van honden Mork & Dash en hoe zij hun frustratie in korte tijd overwonnen met deze methode'].map((item, i) => <div key={`l2-${i}`} className="flex items-start gap-3" data-id="element-2381" data-mp="39obtrggm4sft" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2382" data-mp="3ehn43rkmvrch" />
                        <span className="text-sm text-gray-700" data-id="element-2383" data-mp="3jewsr5077yz9">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2384" data-mp="3od81tdio65gf">
                      Dit leer je in Stap 3
                    </p>
                    {['Effectief samenwerken zodat je op de juiste manier een diepe band opbouwt', 'Drie voorbeeld situaties waarin je de methode in de praktijk brengt'].map((item, i) => <div key={`l3-${i}`} className="flex items-start gap-3" data-id="element-2385" data-mp="17uywv1sw7u00" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2386" data-mp="12vcj8r95kbqo" />
                        <span className="text-sm text-gray-700" data-id="element-2387" data-mp="20g8l84nqz2di">{item}</span>
                      </div>)}

                    <p className="text-[#5ce0d2] font-bold text-sm" data-id="element-2388" data-mp="1vkjtuolvsrsa">
                      Dit leer je in de bonus lessen
                    </p>
                    {['Masterclass hondengeschiedenis. Ontwikkeling van het diersoort en de ontwikkeling van wetenschappelijke onderzoeken en conclusies over hondengedrag.', 'Stress signalen herkennen zodat je weet of je hond hoog of laag in zijn stress zit', '3 Kalmerende activiteiten waarmee je jouw hond kan helpen ontspannen als zijn stress level te hoog is'].map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-2389" data-mp="2m6dpix65j51t" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2390" data-mp="2i63h7duw02js" />
                        <span className="text-sm text-gray-700" data-id="element-2391" data-mp="3etzrk0zqe1mk">{item}</span>
                      </div>)}
                  </div>
                </div>

                {/* First pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2392" data-mp="353omuc883oem">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-2393" data-mp="3134oj5bwyeqw">
                    Liefdevol Communiceren Pakket Actie
                  </div>
                  <div className="p-5 text-center" data-id="element-2394" data-mp="3su0r9d49f30g">
                    <img src="https://cdn.magicpatterns.com/uploads/oEL2JDeiE1fJbhau44wGFR/lc_devices_mockup.png" alt="Liefdevol Communiceren Cursus Training" className="w-full h-auto object-contain mb-4 rounded-lg" data-id="element-2395" data-mp="1fc65tdyhqofj" />
                    <div className="text-gray-500 text-sm" data-id="element-2396" data-mp="1tbpbm03txnoo">
                      <span className="line-through" data-id="element-2397" data-mp="1td8rvqphjyqg">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-3xl mb-1" data-id="element-2398" data-mp="1yaipvuqxxipw">
                      Slechts €127
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-2399" data-mp="280ttthamjrws">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-2" data-id="element-2400" data-mp="2c1dq6indirhv">
                      Cursus + 2 vrije cursussen + digitaal boek. Direct
                      toegang.
                    </p>
                    <p className="text-[#5ce0d2] font-bold text-sm mb-4" data-id="element-2401" data-mp="2lztksvlm0iw4">
                      Per direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-2402" data-mp="lymx12l1xumr">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-2403" data-mp="14n1rjzukvqsb">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2404" data-mp="19o7ibs4oh3z7">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2405" data-mp="3ge5lwc691nhl">
                    Dit is wat anderen zeggen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2406" data-mp="3bhfai25e3g2i">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2407" data-mp="1qx0ev37xjiox">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2408" data-mp="1vwwfcshf4rzq">
                        <Star className="w-4 h-4 fill-current" data-id="element-2409" data-mp="1vy7icq31hvps" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2410" data-mp="1h6xlh1wwc2q2" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2411" data-mp="1m61r5ikm3ibn" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2412" data-mp="1m476849cbq7k" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2413" data-mp="185zc043ov303" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2414" data-mp="1d6n4ku7kfrwf">
                        "Sinds we de cursus volgen, is de band met Max zoveel
                        sterker geworden. We begrijpen elkaar eindelijk!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2415" data-mp="2smm81s68mzqc">
                        - Lisa & Max
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2416" data-mp="2xl6yizvou51l">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2417" data-mp="xi632u8vdl63">
                        <Star className="w-4 h-4 fill-current" data-id="element-2418" data-mp="ti5g2l7pg1nf" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2419" data-mp="tfria4ln4bc6" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2420" data-mp="ohhnvw7qperm" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2421" data-mp="jjy8gszb2vy3" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2422" data-mp="jlslll4c5jrm" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2423" data-mp="elwhzmzjvucl">
                        "Ik dacht dat mijn hond gewoon koppig was, maar dankzij
                        Amee zie ik nu dat hij me iets probeerde te vertellen.
                        Een wereld van verschil."
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2424" data-mp="r3ua19ib7ux">
                        - Mark & Bella
                      </p>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2425" data-mp="3n1g7cax3osmd">
                      <div className="flex text-[#ffb800] mb-2" data-id="element-2426" data-mp="3cx9gp2wuden7">
                        <Star className="w-4 h-4 fill-current" data-id="element-2427" data-mp="3hvkrpgyvhv70" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2428" data-mp="3htzxjsgh0e9o" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2429" data-mp="3mue5zblzhq88" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2430" data-mp="3mst8pe8abt6o" />
                        <Star className="w-4 h-4 fill-current" data-id="element-2431" data-mp="3rt8osdjybesc" />
                      </div>
                      <p className="text-sm text-gray-700 italic mb-2" data-id="element-2432" data-mp="2u7beh3fq6frh">
                        "De rust in huis is teruggekeerd. Geen frustratie meer,
                        maar echte samenwerking. Bedankt!"
                      </p>
                      <p className="text-xs font-bold text-[#1a2b4a]" data-id="element-2433" data-mp="342blfp681psp">
                        - Sarah & Luna
                      </p>
                    </div>
                  </div>
                </div>

                {/* Second pricing CTA */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2434" data-mp="2gdk2loeiujsl">
                  <div className="bg-[#5ce0d2] text-[#1a2b4a] text-center py-3 px-4 font-bold text-sm" data-id="element-2435" data-mp="28cl2yl6sb359">
                    Start met het Liefdevol Communiceren Pakket
                  </div>
                  <div className="p-5 text-center" data-id="element-2436" data-mp="2i2nuegy9c91h">
                    <div className="text-gray-500 text-sm" data-id="element-2437" data-mp="2i5juaato17sk">
                      Totale waarde <span className="line-through" data-id="element-2438" data-mp="2d5e5r3ip01ep">€401</span>
                    </div>
                    <div className="text-[#e53e3e] font-black text-2xl mb-1" data-id="element-2439" data-mp="1pfju2pa40iw1">
                      Slechts €127 vandaag
                    </div>
                    <div className="text-[#e53e3e] font-bold text-sm mb-3" data-id="element-2440" data-mp="1zcy0dw2bjram">
                      (Bespaar €274)
                    </div>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-2441" data-mp="1udbn5mmhqb1t">
                      Inclusief 2 vrije cursussen + digitaal boek "Wat Zegt Jouw
                      Hond?". Direct toegang.
                    </p>
                    <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-lg text-sm" data-id="element-2442" data-mp="35sru4d8bron7">
                      Krijg nu toegang!
                    </a>
                    <p className="text-xs text-gray-500 mt-2" data-id="element-2443" data-mp="38dznxvim665j">
                      Met 365 dagen 100% geld-terug garantie
                    </p>
                  </div>
                </div>

                {/* Bonussen */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2444" data-mp="4ytyu3gfbdj8">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2445" data-mp="3rckbxep7kvey">
                    Inclusief Bonussen
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2446" data-mp="iv7gbckyjexp">
                    {[{
                    title: '30 dagen community toegang',
                    desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies en kom in contact met andere hondenbaasjes."
                  }, {
                    title: 'Printbare Stappenplannen',
                    desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen om er altijd bij te kunnen pakken.'
                  }, {
                    title: 'Levenslange Toegang',
                    desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates van de cursus.'
                  }].map((bonus, i) => <div key={`b-${i}`} className="flex items-start gap-3" data-id="element-2447" data-mp="2y6elbgrddd6" data-mpi={i}>
                        <Check className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-2448" data-mp="2sojezumx8nsp" />
                        <div data-id="element-2449" data-mp="2nnlwti1wvtr7">
                          <p className="font-bold text-sm text-[#1a2b4a]" data-id="element-2450" data-mp="2nnc9y3c5y2pq">
                            {bonus.title}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-2451" data-mp="18567o1vhn9es">{bonus.desc}</p>
                        </div>
                      </div>)}
                  </div>
                </div>

                {/* Video Testimonials */}
                <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden" data-id="element-2452" data-mp="1hwts3itmnq6r">
                  <div className="bg-[#1a2b4a] text-white text-center py-3 px-4 font-bold text-sm" data-id="element-2453" data-mp="1muc1197na5er">
                    Video Testimonials & Interviews
                  </div>
                  <div className="p-5 space-y-4" data-id="element-2454" data-mp="1vwlby06ts0so">
                    {['1084982139', '1084982111', '1084982084'].map(id => <div key={id} className="rounded-lg overflow-hidden shadow-sm" data-id="element-2455" data-mp="20sae8ba8bvso">
                        <iframe src={`https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" className="w-full aspect-[8/9]" title={`Testimonial ${id}`} data-id="element-2456" data-mp="6hevwh98t2cp"></iframe>
                      </div>)}
                  </div>
                </div>

                {/* Final CTA */}
                <div className="bg-[#e6f7f5] rounded-xl p-5 text-center border border-[#5ce0d2]" data-id="element-2457" data-mp="aqk6m5vc88gg">
                  <p className="font-bold text-[#1a2b4a] text-sm mb-3" data-id="element-2458" data-mp="fpnd7uqyumqj">
                    3 stappen tot je hond ontspannen alleen kan blijven
                  </p>
                  <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#5ce0d2] hover:bg-[#4bc9bd] text-[#1a2b4a] font-bold py-3 px-4 rounded-lg text-center transition-colors shadow-md text-sm" data-id="element-2459" data-mp="5s8yq0ols80v">
                    Start nu met de Liefdevol Communiceren Methode
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 19. GUARANTEE */}
      <section className="bg-[#1a2b4a] text-white py-16" data-id="element-2460" data-mp="1dl98x3adyw4n">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2461" data-mp="1dlr37udhn09x">
          <img src="https://cdn.magicpatterns.com/uploads/tPvpNvykR2KiCNK1pkG2LG/1a50ac51aa1d734ab9af0a73cc65b51b.png" alt="100% Money Back Guarantee" className="w-32 h-32 mx-auto mb-6 object-contain" data-id="element-2462" data-mp="pv56v0cuj4fr" />
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-[#ffb800]" data-id="element-2463" data-mp="yp9s9497nnnw">
            De BESTE Geld-Terug Garantie In De Wereld
          </h2>
          <h3 className="text-2xl font-bold mb-8" data-id="element-2464" data-mp="675s7ef5vd52">
            365 dagen niet-goed, geld-terug garantie:
          </h3>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6 max-w-3xl mx-auto text-left" data-id="element-2465" data-mp="25156yj7xere">
            <p data-id="element-2466" data-mp="21a2igq6iuopn">
              Kijk, laat me eerlijk tegen je zijn: Ik weet dat voordat ik ergens
              induik… …ik zelf ook wil weten wat ik koop en dat het wordt
              ondersteund door een sterke geld-terug-garantie. En ik wil dat jij
              je comfortabel voelt bij deze aankoop. Ook al is het maar €127 –
              jij hebt voor dat geld gewerkt en het telt.
            </p>
            <p data-id="element-2467" data-mp="1id9mun9vtbs5">
              Zoals mijn opa altijd zei: "Maak eerst een proefrit, voordat je de
              auto van het terrein afrijdt." Maar hier zit het verschil. Waar de
              meeste mensen je maximaal een garantie van 14 of 30 dagen zouden
              geven… ga ik iets doen wat je waarschijnlijk nog nooit hebt
              gezien.
            </p>
            <p className="font-bold text-white text-xl text-center py-4" data-id="element-2468" data-mp="33puf7bhqmgta">
              Ik geef je 365 dagen om de Liefdevol Communiceren Cursus te
              bekijken en toe te passen.
            </p>
            <p data-id="element-2469" data-mp="x1bwdy0m83pe">
              Ja, je leest het goed. Je krijgt een heel JAAR om deze korte
              training te volgen en toe te passen wat je erin leert. Niet
              slechts een paar weken of een maand. En als je niet volledig
              overdonderd bent door wat je leert… Dan stuur je me gewoon een
              e-mail en vraag je op elk moment binnen die 365 dagen je geld
              terug. We storten je €127 direct terug en je mag toegang tot de
              cursus gratis houden.
            </p>
            <p className="text-center italic mt-8" data-id="element-2470" data-mp="9aohutw72ftv">
              Omdat je nu nog aan het gelezen ben, neem ik aan dat je klaar bent
              om te bestellen, dus met die gedachten...
            </p>
          </div>
        </div>
      </section>

      {/* 20. PRICING CTA */}
      <section className="bg-white py-16 border-b border-gray-200" data-id="element-2471" data-mp="1yqnx8sqep1hy">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-2472" data-mp="1trbbkbb9u0gy">
          <p className="text-[#5ce0d2] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-2473" data-mp="1ts4cgvnjtvr6">
            Liefdevol Communiceren Pakket Actie
          </p>
          <h2 className="text-4xl font-black text-[#1a2b4a] mb-2" data-id="element-2474" data-mp="vg0fus8rdqx6">
            Vandaag voor €127
          </h2>
          <h3 className="text-2xl font-bold text-[#e53e3e] mb-6" data-id="element-2475" data-mp="hgiktv4vdhfd">
            (Bespaar €274)
          </h3>
          <img src="https://cdn.magicpatterns.com/uploads/9QvtvBrW74TzrCyCAwHwpa/lc_booklet_mockup.png" alt="Liefdevol Communiceren Stappenplan" className="w-full max-w-md mx-auto mb-8 mix-blend-multiply" data-id="element-2476" data-mp="mdr6w6t525lw" />
          <p className="text-lg text-gray-600 mb-8" data-id="element-2477" data-mp="cih0l6vpjc2b">
            Start met het complete Liefdevol Communiceren Pakket voor{' '}
            <span className="line-through" data-id="element-2478" data-mp="3nsvbgq4tudi">€401</span> slechts €127! Inclusief 2
            gratis cursussen naar keuze en het digitale boek "Wat Zegt Jouw
            Hond?". Direct toegang.
          </p>
          <div className="max-w-md mx-auto" data-id="element-2479" data-mp="3pvslcyt42el1">
            <CTAButton data-id="element-2480" data-mp="3pxn549snc0nj" />
            <p className="text-sm text-gray-500 mt-4 font-bold" data-id="element-2481" data-mp="369qx26ofgk9f">
              Met 365 dagen 100% geld terug garantie.
            </p>
          </div>
        </div>
      </section>

      {/* 21. WHAT YOU GET GRID */}
      <section className="bg-[#faf5eb] py-16" data-id="element-2482" data-mp="3g8g93itn7ahr">
        <div className="max-w-6xl mx-auto px-4" data-id="element-2483" data-mp="3g983wrff146z">
          <h2 className="text-3xl font-black text-[#1a2b4a] text-center mb-12" data-id="element-2484" data-mp="3b8am4fybic60">
            Dit is wat je krijgt met de training
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2485" data-mp="3p71v5nybp7na">
            {[{
            title: 'Liefdevol Communiceren Cursus',
            desc: 'Volledige training in hoe je de Liefdevol Communiceren Methode inzet.',
            image: 'https://cdn.magicpatterns.com/uploads/pPc7pHdzhv1XesyMhYPzEV/lc_book_mockup.png'
          }, {
            title: '30 dagen ondersteuning via Community',
            desc: "Stuur vragen, foto's en videos naar onze experts, neem deel aan meerdere wekelijkse online coachingsessies.",
            image: 'https://cdn.magicpatterns.com/uploads/8mzMhue5NATuWpex23cfs6/2.png'
          }, {
            title: 'Levenslange Toegang',
            desc: 'Je krijgt levenslange toegang tot al het lesmateriaal, inclusief alle toekomstige updates.',
            image: 'https://cdn.magicpatterns.com/uploads/5xTMXACWhxH6FRP25sk6Rf/4.png'
          }, {
            title: 'Printbare Stappenplannen',
            desc: 'Handige, printbare overzichten van alle lichaamssignalen en kalmerende signalen.',
            image: 'https://cdn.magicpatterns.com/uploads/dAT5SmJ1D7wjLPsXTfaXi4/3.png'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl overflow-hidden shadow-md flex flex-col h-full" data-id="element-2486" data-mp="39cdlg0qb8czv" data-mpi={i}>
                <div className="bg-[#5ce0d2] text-[#1a2b4a] font-bold text-center py-2 text-xs uppercase tracking-wider" data-id="element-2487" data-mp="36qxh2x7df29i">
                  INBEGREPEN BIJ JE BESTELLING
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-2488" data-mp="31ycqs5nob7aq">
                  <div className="w-full h-48 rounded-lg mb-4 flex items-center justify-center overflow-hidden" data-id="element-2489" data-mp="2x1w4lh01b30a">
                    <img src={item.image} alt={item.title} className="w-full h-full object-contain" data-id="element-2490" data-mp="2s3kqgu2pi6c9" />
                  </div>
                  <h4 className="font-bold text-[#1a2b4a] mb-2 leading-tight" data-id="element-2491" data-mp="3kom348d6cfg5">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-auto" data-id="element-2492" data-mp="3asrd2s6mfi3c">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 22. BOTTOM CTA BAR */}
      <div className="bg-[#ffb800] py-8 text-center px-4" data-id="element-2493" data-mp="1zcueec8zdjsx">
        <div className="max-w-md mx-auto" data-id="element-2494" data-mp="1zfgig1wnxh6e">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-[#1a2b4a] hover:bg-black text-white font-bold py-4 px-4 rounded-lg text-xl transition-colors shadow-lg" data-id="element-2495" data-mp="2p186t1n8s5hw">
            Krijg nu toegang!
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-2496" data-mp="2k36edq3xettr">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 24. TURID RUGAAS QUOTE */}
      <section className="bg-white py-16" data-id="element-2497" data-mp="3cq0y2ksx5p66">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8" data-id="element-2498" data-mp="3csws3y1nbtpc">
          <div className="flex-1 text-center md:text-left" data-id="element-2499" data-mp="2yxurnqfkiwjx">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-2500" data-mp="32zy4aidz476s">
              Meestal zijn wij, de menselijke soort, degenen die conflicten
              creëren tussen onze honden en onszelf
            </h2>
            <p className="text-lg text-gray-700 mb-2" data-id="element-2501" data-mp="3vjekg1ikgna6">
              <strong data-id="element-2502" data-mp="1k1jhaq3sspjc">Turid Rugaas</strong>, wereldberoemde Noorse
              hondentrainster, auteur en expert in hondentaal
            </p>
            <p className="text-xs text-gray-400 uppercase tracking-wide" data-id="element-2503" data-mp="1f1nl3d1ce2ec">
              DISCLAIMER: Dit is geen aanbeveling van Turid Rugaas
            </p>
          </div>
          <div className="w-48 h-48 flex-shrink-0" data-id="element-2504" data-mp="1ottbwjfuydry">
            <img src="https://cdn.magicpatterns.com/uploads/5u3DrMLHNnG7KPDoQAwX5E/e34559c94a8bf7103f4c6cb20d81f245.jpg" alt="Turid Rugaas" className="w-full h-full object-cover rounded-xl shadow-lg grayscale" data-id="element-2505" data-mp="113748t9rmvih" />
          </div>
        </div>
      </section>

      {/* 25. FAQ */}
      <section className="bg-[#faf5eb] py-16" data-id="element-2506" data-mp="1620jor8m4wla">
        <div className="max-w-5xl mx-auto px-4" data-id="element-2507" data-mp="2mh1t428tt0o5">
          <h2 className="text-4xl font-black text-[#1a2b4a] text-center mb-16" data-id="element-2508" data-mp="2mfqok07k3ovz">
            Veelgestelde vragen
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-2509" data-mp="2hk305n0wezrj">
            {[{
            q: 'Ik wil dit, wat krijg ik exact?',
            a: 'Na je aankoop ontvang je een email met een inlogcode tot ons leerplatform. In dit platform vind je drie uitgebreide modules waarin je alles leert over de Liefdevol Communiceren Methode.'
          }, {
            q: 'Wat is de Liefdevol Communiceren Methode?',
            a: 'Dit is een nieuwe methode waarin je de taalbarrière tussen jou en je hond doorbreekt in plaats van je alleen maar te richten op commanderen. Wij gebruiken deze methode om jaarlijks bij honderden honden gedragsproblemen bij de kern aan te pakken en op te lossen.'
          }, {
            q: 'Kan ik meer hulp krijgen als ik dit wil?',
            a: 'Ja, er is een knop om in contact te komen met iemand van ons team die je meer kan uitleggen over onze 1-op-1 hulp.'
          }, {
            q: 'Wat maakt dit anders dan alle andere informatie online?',
            a: 'Alles wat je kan vinden gaat alleen maar over gehoorzaamheid en correcties. Met deze methode kijk je naar de taal die je hond spreekt, pak je de miscommunicatie bij de kern aan en ga je daarna pas samenwerken. Op deze manier heb je sneller, beter en blijvend resultaat.'
          }, {
            q: 'Voor wie is dit?',
            a: 'Dit is voor hondenbaasjes die de gedragsproblemen van hun hond nu voor eens en altijd willen oplossen en dit op een empatische, liefdevolle manier willen doen.'
          }, {
            q: 'Is er een garantie?',
            a: 'Ja, je krijgt een 365 dagen niet-goed, geld-terug garantie voor het geval je toch niet tevreden bent.'
          }].map((faq, i) => <div key={i} data-id="element-2510" data-mp="33dqi874zaca1" data-mpi={i}>
                <h4 className="font-bold text-xl text-[#1a2b4a] mb-3 flex items-start gap-3" data-id="element-2511" data-mp="33hmq72m72c22">
                  <HelpCircle className="w-6 h-6 text-[#5ce0d2] flex-shrink-0 mt-0.5" data-id="element-2512" data-mp="38ca7agevc46m" />
                  {faq.q}
                </h4>
                <p className="text-[#5ce0d2] pl-9 leading-relaxed" data-id="element-2513" data-mp="19w1axlqsgnr0">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WANDELINGEN-BEELD */}
      <section className="bg-[#faf5eb] py-12" data-id="element-2514" data-mp="107181r96187j">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-2515" data-mp="1068b1i00dx2l">
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium" data-id="element-2516" data-mp="v86hg34yifcv">
            Hoe vaak per dag laat jij je hond uit? Drie keer? Vier keer?
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-2517" data-mp="m6yugh7w50y3">
            Dat zijn{' '}
            <span className="font-black text-[#1a2b4a]" data-id="element-2518" data-mp="h8f7cdhk9j45">
              honderden wandelingen per jaar
            </span>
            . Honderden momenten samen.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed font-medium mt-4" data-id="element-2519" data-mp="2ginc4r5ibhm6">
            Waarom zouden jullie al die momenten doorbrengen met frustratie en
            spanning, als het ook{' '}
            <span className="text-[#5ce0d2] font-bold" data-id="element-2520" data-mp="2o4ipyb5lxfp8">
              ontspannen en verbonden
            </span>{' '}
            kan?
          </p>
          <p className="text-lg text-gray-500 mt-6 italic" data-id="element-2521" data-mp="2swk4k3q8ziif">
            Eén kleine verandering in hoe jij communiceert, verandert élke
            wandeling. Elke ochtend. Elke avond. Voorgoed.
          </p>
        </div>
      </section>

      {/* 26. FINAL CTA */}
      <div className="bg-[#ffb800] py-12 text-center px-4" data-id="element-2522" data-mp="2554wdubsi6z9">
        <div className="max-w-md mx-auto" data-id="element-2523" data-mp="257r3xtyokmhh">
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="block w-full bg-transparent border-4 border-[#1a2b4a] text-[#1a2b4a] hover:bg-[#1a2b4a] hover:text-white font-black py-4 px-4 rounded-lg text-2xl transition-colors" data-id="element-2524" data-mp="2a4hsl5ojwqei">
            Start met deze cursus
          </a>
          <p className="text-sm text-[#1a2b4a] mt-3 font-bold" data-id="element-2525" data-mp="3o4cl2962hnxz">
            Met 365 dagen 100% geld-terug garantie
          </p>
        </div>
      </div>

      {/* 27. FOOTER */}
      <footer className="bg-[#111827] text-gray-400 py-12 text-xs leading-relaxed text-center px-4" data-id="element-2526" data-mp="3k4u0jei5revo">
        <div className="max-w-5xl mx-auto space-y-6" data-id="element-2527" data-mp="1v1jg53eiros">
          <p className="font-bold text-white mb-8" data-id="element-2528" data-mp="3t2e1emc3z95r">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6 border-y border-gray-800 py-8 mb-8" data-id="element-2529" data-mp="kncejcrtdlcc">
            <p className="font-bold text-white" data-id="element-2530" data-mp="fpkfzzwnz0z6">
              Copywriting van Stressless Dogs Nederland BV
            </p>
            <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] hover:bg-[#e6a600] text-[#1a2b4a] font-bold py-3 px-8 rounded-lg text-lg transition-colors" data-id="element-2531" data-mp="umbjak9gkwu2">
              Start met de cursus.
            </a>
          </div>

          <p className="text-justify" data-id="element-2532" data-mp="zab4127425of">
            We can not and do not make any guarantees about your ability to get
            results or earn any money with our ideas, information, tools, or
            strategies. What we can guarantee is your satisfaction with our
            training. We give you a 30-day 100% satisfaction guarantee on the
            products we sell, so if you are not happy for any reason with the
            quality of our training, just ask for your money back. You should
            know that all products and services by our company are for
            educational and informational purposes only. Nothing on this page,
            any of our websites, or any of our content or curriculum is a
            promise or guarantee of results or future earnings, and we do not
            offer any legal, medical, tax or other professional advice. Any
            financial numbers referenced here, or on any of our sites, are
            illustrative of concepts only and should not be considered average
            earnings, exact earnings, or promises for actual or future
            performance. Use caution and always consult your accountant, lawyer
            or professional advisor before acting on this or any information
            related to a lifestyle change or your business or finances. You
            alone are responsible and accountable for your decisions, actions
            and results in life, and by your registration here you agree not to
            attempt to hold us liable for your decisions, actions or results, at
            any time, under any circumstance.
          </p>
        </div>
      </footer>

      {/* 23. STICKY BOTTOM BAR */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#1a2b4a] border-t-4 border-[#5ce0d2] p-3 flex items-center justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" data-id="element-2533" data-mp="2h87ggbo6c2k0">
        <div className="flex items-center justify-between md:justify-center gap-3 md:gap-8 w-full max-w-5xl" data-id="element-2534" data-mp="wo2d56z8eofa">
          <div className="flex items-center gap-3 md:gap-6" data-id="element-2535" data-mp="16o30d4081oor">
            <img src="https://cdn.magicpatterns.com/uploads/kbsUp8Jcv8Ni5jP2oc579N/Ontwerp_zonder_titel_(70).png" alt="Liefdevol Communiceren Boek" className="hidden md:block w-16 h-auto object-contain" data-id="element-2536" data-mp="16mi85l1dqhu2" />
            <img src="https://cdn.magicpatterns.com/uploads/fnqxQ7hwmYLpvvLjHhPAxX/Ontwerp_zonder_titel_(69).png" alt="Liefdevol Communiceren Cursus" className="w-16 md:w-24 h-auto object-contain" data-id="element-2537" data-mp="1keyb6lua6fuz" />
            <div data-id="element-2538" data-mp="1ubkx7dycfcyl">
              <div className="text-white font-bold text-sm md:text-base leading-tight" data-id="element-2539" data-mp="3r5xhmn2psfk0">
                Liefdevol Communiceren Cursus
              </div>
              <div className="text-[#5ce0d2] font-black text-lg md:text-xl" data-id="element-2540" data-mp="fnbrwny4at">
                <span className="text-red-500 line-through decoration-[3px] mr-2" data-id="element-2541" data-mp="21wenvv45ky3k">
                  €197
                </span>
                €127
              </div>
            </div>
          </div>
          <a href="https://afrekenen.stresslessdogs.nl/checkout/liefdevol-communiceren-webinar-2bonuscursussen" className="bg-[#ffb800] text-[#1a2b4a] font-bold py-2 px-6 md:px-8 md:py-3 rounded-lg text-sm md:text-base shadow-md whitespace-nowrap" data-id="element-2542" data-mp="2bn9d98cp4dt8">
            Naar Stap #2
          </a>
        </div>
      </div>
    </div>;
}